import { observer } from "mobx-react-lite";
import "./AvatarSkeleton.css";
import { AvatarDragOverlay } from "./AvatarDragOverlay";

const AvatarSkeleton = observer(() => {
  return (
    <>
      <AvatarDragOverlay />

      <div id="pyne-avatar-skeleton">
        <div id="pyne-avatar-skeleton-small-circle"></div>
      </div>
    </>
  );
});

export default AvatarSkeleton;
